import {connect} from "redux-vue";
import classNames from 'classnames';
import * as moduleActions from "../actions/module";
import LoadingIndicator from "./LoadingIndicator";

const ModuleCard = {
  /**
   *
   */
  props: ["user", "modelProp", "setModule", "enrollModule", "module", "highlight"],

  /**
   *
   */
  methods: {
    onPressDetails() {
      this.setModule(this.modelProp);
      this.$router.push("/en/courses/" + this.modelProp.id + "/details");
    },
    onPressEnroll () {
      const isAuthorized = !!(this.user.token && this.user.model);
      if (!isAuthorized) {
        this.$router.push({name: 'RegisterModal'});
      } else {
        const hasActivity = (this.modelProp.lessons || []).some(lesson => !!lesson.activities.length);
        if (hasActivity) {
          this.enrollModule(this.modelProp);
        } else {
          Snackbar.show({
            text: 'This module will be available soon',
            actionText: 'Dismiss',
          });
        }
      }
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    const mobileClass = classNames(
      "mdi text-teal-800 text-sm lg:text-base",
      this.modelProp.mobile ? 'mdi-cellphone' : 'mdi-cellphone-off opacity-25'
    );
    const desktopClass = classNames(
      "mdi text-teal-800 text-sm lg:text-base",
      this.modelProp.desktop ? 'mdi-laptop' : 'mdi-laptop-off opacity-25'
    );
    const highlight = this.highlight || "";
    const filterRegEx = new RegExp(highlight, "gi");
    const replaceFn = string => {
      return `<span class="bg-yellow-400">${string}</span>`
    };
    return (
      <div class="flex flex-col bg-white rounded-md overflow-hidden h-full">
        <div class="h-32 bg-cover bg-gray-200"
             style={`background-image: url(${this.modelProp.photo})`}>
          {Boolean(this.modelProp.new) && (
            <div class="relative">
              <span
                class="absolute bg-green-300 h-8 origin-center right-0 rotate-45 top-0 transform translate-x-8 -translate-y-px w-32"></span>
              <i class="mdi mdi-star text-gray-800 text-2xl absolute top-0 right-0 mr-3 mt-1"></i>
            </div>
          )}
        </div>
        <div class="p-3 px-6 flex-1">
          <p domPropsInnerHTML={highlight.length > 1
            ? this.modelProp.description.replace(filterRegEx, replaceFn)
            : this.modelProp.description} class="uppercase text-2xs font-bold mb-2 text-gray-900">
          </p>
          <p class="font-serif italic text-teal-800 text-lg" domPropsInnerHTML={highlight.length > 1
            ? this.modelProp.name.replace(filterRegEx, replaceFn) : this.modelProp.name}>
          </p>
        </div>
        <div class="pb-6 px-6">
          <div class="flex items-center justify-between">
            <button onClick={this.onPressEnroll} type="button" disabled={this.module.enroll}
                    class="bg-yellow-500 p-2 px-3 rounded-full italic font-serif text-2xs focus:outline-none">
              {this.module.enroll
                ? <LoadingIndicator/>
                : <fragment>Enroll <i class="mdi mdi-arrow-right ml-1"></i></fragment>
              }
            </button>

            <div class="flex mr-auto ml-3 lg:mx-0">
              <div class="h-6 lg:h-8 w-6 lg:w-8 bg-teal-100 rounded-full">
                <div class="h-full w-full flex items-center justify-center">
                  <i class={mobileClass}></i>
                </div>
              </div>
              <div class="w-1"></div>
              <div class="h-6 lg:h-8 w-6 lg:w-8 bg-teal-100 rounded-full">
                <div class="h-full w-full flex items-center justify-center">
                  <i class={desktopClass}></i>
                </div>
              </div>
            </div>

            <button type="button" onClick={this.onPressDetails} class="text-blue-700 font-bold text-2xs focus:outline-none">
              View Details
            </button>
          </div>
        </div>
      </div>
    );
  }
};

function mapStateToProps(state) {
  return {
    user: state.user,
    module: state.module,
  };
}

function mapActionToProps(dispatch) {
  return {
    setModule: module => dispatch(moduleActions.setModule(module)),
    enrollModule: async module => await dispatch(moduleActions.enrollModule(module))
  };
}

export default connect(mapStateToProps, mapActionToProps)(ModuleCard);
